import styled from 'styled-components'

import Button from '../../Button'

const StyledButton = styled(Button)`
  padding: 0;
`

export default StyledButton
